export default "__VITE_ASSET__BrWcA2K$__"